import React, { Component } from "react"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import TimeLine from "../../components/TimeLine/TimeLine"
import experience from "../../constants/Experience"
import education from "../../constants/Education"
import mainSkills from "../../constants/MainSkills"
import SkillBar from "../../components/SkillBar/SkillBar"
import { FormattedMessage } from "gatsby-plugin-react-intl"
class TabsTwo extends Component {
  render() {
    let tab1 = <FormattedMessage id="skillsTitle" />,
      tab3 = <FormattedMessage id="experienceTitle" />,
      tab4 = <FormattedMessage id="educationTitle" />
    const { tabStyle } = this.props
    return (
      <div>
        {/* Start Tabs Area */}
        <div className="tabs-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Tabs>
                  <TabList className={`${tabStyle}`}>
                    <Tab>{tab1}</Tab>
                    {/* <Tab>{tab2}</Tab>*/}
                    <Tab>{tab3}</Tab>
                    <Tab>{tab4}</Tab>
                  </TabList>

                  <TabPanel>
                    <div className="single-tab-content">
                      {/*  <ul>
                        <li>
                          <a href="/service">
                            Web Development <span> - Development</span>
                          </a>
                          Build websites and web apps using javascript and it's
                          frameworks.
                        </li>
                        <li>
                          <a href="/service">
                            Web and user interface design<span> - Design</span>
                          </a>
                          Websites, web experiences, ...
                        </li>
                        <li>
                          <a href="/service">
                            Mechanical Engineering <span> - Engineering</span>
                          </a>
                          Mechanical design, problem solving, ...
                        </li>
                      </ul> */}
                      {mainSkills.map((skill, key) => (
                        <div className="row" key={key}>
                          <div
                            className="col-lg-3"
                            style={{ textAlign: "center", marginTop: "15px" }}
                          >
                            <h4>{skill.title}</h4>
                          </div>

                          <div className="col-lg-9">
                            <SkillBar value={skill.value} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </TabPanel>

                  {/* <TabPanel>
                    <div className="single-tab-content">
                      <ul>
                        <li>
                          <a href="/service">
                            Awwwards.com <span>- Winner</span>
                          </a>{" "}
                          2019 - 2020
                        </li>
                        <li>
                          <a href="/service">
                            CSS Design Awards <span>- Winner</span>
                          </a>{" "}
                          2017 - 2018
                        </li>
                        <li>
                          <a href="/service">
                            Design nominees <span>- site of the day</span>
                          </a>{" "}
                          2013- 2014
                        </li>
                      </ul>
                    </div>
                  </TabPanel>
*/}
                  <TabPanel>
                    <div
                      className="single-tab-content"
                      style={{ weight: "80vw" }}
                    >
                      <TimeLine list={experience} />
                      {/* <ul>
                        <li>
                          <a href="/service">
                            Sr. Front-end Engineer<span> - Google</span>
                          </a>{" "}
                          2018 - Current
                        </li>
                        <li>
                          <a href="/service">
                            Front-end Engineer<span> - Microsoft</span>
                          </a>{" "}
                          2017 - 2018
                        </li>
                        <li>
                          <a href="/service">
                            Software Engineer<span> - Alibaba </span>
                          </a>{" "}
                          2013- 2014
                        </li>
                      </ul> */}
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <TimeLine list={education} />
                      {/*  <ul>
                        <li>
                          <a href="/service">
                            BSc In Mechanical Engineering
                            <span> - Mosul University, Iraq</span>
                          </a>{" "}
                          2019
                        </li>
                        <li>
                          <a href="/service">
                            Full-Stack web development certification
                            <span> - Kodluyoruz, Turkey</span>
                          </a>{" "}
                          2021
                        </li>
                        <li>
                          <a href="/service">
                            React Development certification
                            <span> - Re:Coded, IQ</span>
                          </a>{" "}
                          2021
                        </li>
                      </ul> */}
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {/* End Tabs Area */}
      </div>
    )
  }
}

export default TabsTwo
